import "./LabDirectorDetailsComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LabDirectorDetailsEditComponent from "./lab-director-details-edit/LabDirectorDetailsEditComponent";
import LabDirectorDetailsViewComponent from "./lab-director-details-view/LabDirectorDetailsViewComponent";

interface LabDirectorDetailsComponentProps {
    directorDetails: any;
    labDetails: any;
    labID: string | undefined;
    handleLabDetailsUpdate: (labBasicDetails: any) => void;
    onModeChange: any;
    canEdit: boolean;
}

const LabDirectorDetailsComponent = (props: LabDirectorDetailsComponentProps) => {
    const {directorDetails, handleLabDetailsUpdate, labID, onModeChange, canEdit, labDetails} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [labDirectorDetails, setLabDirectorDetails] = useState<any>(undefined);

    const handleLabDirectorDetailsUpdate = useCallback((updatedLabDetails: any) => {
        handleLabDetailsUpdate(updatedLabDetails);
        setMode("view");
    }, [handleLabDetailsUpdate]);

    const handleLabDirectorDetailsEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (directorDetails) {
            setLabDirectorDetails(directorDetails);
        }
    }, [directorDetails]);

    useEffect(() => {
        onModeChange(mode)
    }, [mode, onModeChange])

    return (
        <div className="lab-information-and-contact-details-component details-tab-data-wrapper">
            {
                mode === "view" && <LabDirectorDetailsViewComponent
                    directorDetails={labDirectorDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <LabDirectorDetailsEditComponent
                    labID={labID}
                    labDetails={labDetails}
                    handleLabDetailsUpdate={handleLabDetailsUpdate}
                    onUpdateComplete={handleLabDirectorDetailsUpdate}
                    onEditCancel={handleLabDirectorDetailsEditCancel}
                />
            }
        </div>
    );

};

export default LabDirectorDetailsComponent;
